import { render, staticRenderFns } from "./addRoomSidebar.vue?vue&type=template&id=641bbdd9&scoped=true&"
import script from "./addRoomSidebar.vue?vue&type=script&lang=js&"
export * from "./addRoomSidebar.vue?vue&type=script&lang=js&"
import style0 from "./addRoomSidebar.vue?vue&type=style&index=0&id=641bbdd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bbdd9",
  null
  
)

export default component.exports